import Logo from '@/components/Logo.tsx';
import { useParticlesOptions } from '@/features/login/useParticlesOptions.ts';
import { Paper } from '@arsnovasystems/ars-front-lib';
import { Stack } from '@mui/material';
import Box from '@mui/material/Box';
import { useEffect } from 'react';
import { Outlet } from 'react-router';

/**
 * OnBoarding layout component
 *
 * @returns JSX of the component
 */
export const OnBoardingLayout = () => {
  const options = useParticlesOptions();
  useEffect(() => {
    // eslint-disable-next-line i18next/no-literal-string
    window.particlesJS('particles-js', options);
  }, [options]);

  return (
    <Box
      sx={{
        backgroundColor: '#222637',
        height: '100%',
        position: 'relative',
      }}
    >
      <Box
        sx={{
          height: '100%',
          position: 'absolute',
          left: 0,
          right: 0,
          bottom: '5px', // Avoid weird scrollbar addition
        }}
        id='particles-js'
      ></Box>
      <Stack
        sx={() => ({
          justifyContent: 'center',
          alignItems: 'center',
          paddingTop: '150px',
          backgroundColor: '#222637',
        })}
      >
        <Paper
          sx={(theme) => ({
            paddingY: 4,
            paddingX: 6,
            boxShadow: theme.shadowsCustom.softPaper,
            [theme.breakpoints.up('md')]: {
              width: '1000px',
            },
            [theme.breakpoints.up('lg')]: {
              width: '1200px',
            },
            [theme.breakpoints.up('xl')]: {
              width: '1400px',
            },
            transition: 'max-height 0.15s ease-out',
          })}
        >
          <Stack
            sx={{
              alignItems: 'center',
              minHeight: 300,
              justifyContent: 'space-between',
              height: '100%',
              transition: 'max-height 0.15s ease-out',
            }}
          >
            <Logo
              disableOnClick={true}
              sx={{
                marginBottom: 2,
                width: 'fit-content',
              }}
            />

            <Outlet />
          </Stack>
        </Paper>
      </Stack>
    </Box>
  );
};
